class MessagingConnection {
	private listeners = new Set<() => void>();
	private connected = false;

	subscribe = (listener: () => void) => {
		this.listeners.add(listener);
		return () => this.listeners.delete(listener);
	};
	snapshot = () => this.connected;

	set(connected: boolean) {
		if (this.connected === connected) {
			return;
		}

		this.connected = connected;

		for (const listener of this.listeners) {
			listener();
		}
	}
}

export const messagingConnection = new MessagingConnection();
